angular.module('impactx.catalog').controller('CatalogReplaceCtrl', [
    '$scope',
    'dataGen',
    'ToolbarService',
    'ToastService',
    'TranslationService',
    'BackService',
    CatalogReplaceCtrl]);

function CatalogReplaceCtrl($scope, dataGen, ToolbarService, ToastService, TranslationService, BackService) {
    var ctrl = this;
    $scope.errorList = [];
    var relationSelectionIndex = 0;
    var companySelectionIndex = 1;
    var catalogSelectionIndex = 2;
    var summaryIndex = 3;

    $scope.wizardIndex = relationSelectionIndex;

    dataGen.getData($scope, {}, "/catalog/replace/view").then(function () {
        ToolbarService.setButtons([]);
        ctrl.validate();
    });

    this.save = function () {
        dataGen.postAsForm($scope, {data: $scope.data}, "/catalog/replace/save").then(function () {
            ToastService.openStandardToast($scope.trns.sendSuccess);
        });
    };

    this.forward = function () {
        $scope.wizardIndex++;
        if ($scope.wizardIndex === summaryIndex) {
            dataGen.postAsForm({}, {data: $scope.data}, "/catalog/replace/summary").then(function (data) {
                $scope.data.replacementInfos = data.data.replacementInfos;
            })
        }
        else if ($scope.wizardIndex === summaryIndex + 1) {
            dataGen.postAsForm({}, {data: $scope.data}, "/catalog/replace/save").then(function (data) {
                ToastService.openStandardToast(TranslationService.get('saveSuccess'));
                BackService.back();
            })
        }
        ctrl.validate();
    };

    this.back = function () {
        if ($scope.wizardIndex === relationSelectionIndex) {
            BackService.back();
        }
        else {
            $scope.wizardIndex--;
            ctrl.validate();
        }
    };

    this.validate = function () {
        $scope.errorList.length = 0;
        if ($scope.wizardIndex === relationSelectionIndex) {
            if (!impactX.isDefined($scope, 'data.userRelation.value') &&
                !impactX.isDefined($scope, 'data.companyRelation.value') &&
                !impactX.isDefined($scope, 'data.userGroupRelation.value')) {
                $scope.errorList.push($scope.trns.error_noRelationSelected)
            }
        }
        else if ($scope.wizardIndex === companySelectionIndex) {
            if ($scope.data.companySelection.setId === 1 &&
                $scope.data.relatedCompanies.assigned.length === 0) {
                $scope.errorList.push($scope.trns.error_noCompanySelected)
            }
        }
        else if ($scope.wizardIndex === catalogSelectionIndex) {
            if ($scope.data.sourceCatalogs.assigned.length === 0 ||
                $scope.data.replacedCatalogs.assigned.length === 0) {
                $scope.errorList.push($scope.trns.error_noCatalogSelected)
            }
        }
    };

    this.onUXEvent = function () {
        ctrl.validate();
    };
}
